module.exports = "/_next/static/images/OgDeveloperCenter-15dad132a88ab56be99d73a6dda4e330.png";